"use client";

import { useRouter } from "next/navigation";
import { I } from "@/components/kamibot-v2/discord";
import { useAuth } from "@/contexts/AuthContext";

type HeroNavProps = {
  theme: "light" | "dark";
  setTheme: (t: "light" | "dark") => void;
  /** Hero CTA("서버에 초대")용 핸들러. 헤더 우측 버튼은 더 이상 초대 버튼이 아니라 대시보드 진입 버튼이라 사용하지 않음. */
  onInvite: () => void;
};

// onInvite는 Hero 외부 호환성을 위해 prop으로 남겨두지만 헤더 자체에서는 사용하지 않습니다.
// (헤더 우측 CTA가 대시보드 진입 버튼으로 변경됨)
export function HeroNav({ theme, setTheme }: HeroNavProps) {
  const router = useRouter();
  const { user, login } = useAuth();

  const handleDashboard = () => {
    if (user) {
      // 이미 로그인된 상태 → 바로 대시보드로
      router.push("/dashboard");
    } else {
      // 미로그인 → Discord OAuth 로 보냄. 콜백은 /dashboard 로 돌아옴.
      login("/dashboard");
    }
  };

  return (
    <nav className="nav">
      <div className="shell nav-inner">
        <a href="#" className="brand">
          <span className="brand-mark">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/kamibot-character/kamibot-portrait.png" alt="" />
          </span>
          <span className="brand-name">
            카미봇
            <small>v3.2</small>
          </span>
        </a>
        <div className="nav-links">
          <a className="nav-link" href="#features">기능</a>
          <a className="nav-link" href="#start">시작하기</a>
          <a className="nav-link" href="#support">멤버십</a>
          <a className="nav-link" href="#faq">FAQ</a>
        </div>
        <div className="nav-spacer" />
        <button
          type="button"
          className="theme-btn"
          aria-label="테마 전환"
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
        >
          {theme === "dark" ? <I.sun /> : <I.moon />}
        </button>
        <button type="button" className="nav-cta" onClick={handleDashboard}>
          <I.gear />
          <span>대시보드로 이동</span>
        </button>
      </div>
    </nav>
  );
}
